module.exports = __webpack_public_path__ + "static/media/ransomware.8ee94b6b.png";